const nl: Record<string, string> = {
  // ── Navigatie ──
  nav_home: 'Home',
  nav_shop: 'Shop',
  nav_blueProtect: 'Blue Protect',
  nav_evilEnergy: 'Evil Energy',
  nav_destroyKit: 'Destroy Kit',
  nav_consultations: 'Consultaties',
  nav_blog: 'Blog',
  nav_about: 'Over Ons',
  nav_contact: 'Contact',
  nav_bookConsult: 'Boek Consult',
  nav_myOrders: 'Mijn Bestellingen',

  // ── Hero ──
  hero_badge: 'Geworteld in Sjamanisme · Ouder dan de Tijd',
  hero_title1: 'Elevate Your',
  hero_title2: 'Energy',
  hero_shamBadge: '✦ Sjamanisme ✦',
  hero_shamLabel: 'Sjamanisme',
  hero_shamDesc: 'is een van de oudste spirituele praktijken ter wereld en heeft zijn wortels in inheemse tradities en culturen over de hele wereld — de bron van al onze rituelen.',
  hero_subtitle: 'Premium spirituele producten, energie-reinigingen en persoonlijke consultaties. Gebaseerd op duizenden jaren sjamaanse beschermingskennis.',
  hero_shopNow: 'Shop Nu',
  hero_discoverCollection: 'Ontdek Collectie',

  // ── Vertrouwensbadges ──
  trust_worldwide: 'Wereldwijde Verzending',
  trust_quality: 'Premium Kwaliteit',
  trust_guarantee: '30 Dagen Garantie',
  trust_payment: 'Veilig Betalen',

  // ── Footer ──
  footer_followText: 'Volg ons voor dagelijkse inspiratie uit de wereld van',
  footer_shamanism: 'sjamanisme',
  footer_followEnd: '& spirituele bescherming',
  footer_brandDesc: 'Geworteld in sjamanisme — een van de oudste spirituele praktijken ter wereld. Authentieke beschermingsrituelen, heilige tools en persoonlijke consultaties voor iedereen die zijn bewustzijn wil verheffen.',
  footer_shopTitle: 'Webwinkel',
  footer_infoTitle: 'Informatie',
  footer_newsletterTitle: 'Nieuwsbrief',
  footer_newsletterDesc: 'Ontvang spirituele tips, exclusieve aanbiedingen en nieuwe rituelen.',
  footer_newsletterPlaceholder: 'jouw@email.nl',
  footer_newsletterBtn: 'Aanmelden',
  footer_copyright: '© 2026 ZpiritualZ. Alle rechten voorbehouden.',
  footer_privacy: 'Privacybeleid',
  footer_terms: 'Algemene Voorwaarden',
  footer_cookies: 'Cookies',
  footer_ship_worldwide: 'Wereldwijde Verzending',
  footer_ship_worldwide_sub: 'Wij posten naar elk land',
  footer_ship_fast: 'Snelle Verwerking',
  footer_ship_fast_sub: 'Bestelling snel verstuurd',
  footer_ship_discreet: 'Discreet Verpakt',
  footer_ship_discreet_sub: 'Zonder opvallende opdruk',
  footer_ship_contact: 'Persoonlijk Contact',
  footer_ship_contact_sub: 'Altijd bereikbaar via WhatsApp',

  // ── Footer shop links ──
  footer_link_blueProtect: 'Blue Protect Serie',
  footer_link_crystals: 'Kristallen & Edelstenen',
  footer_link_aroma: 'Aromatherapie',
  footer_link_chakra: 'Chakra Healing',
  footer_link_supp: 'Supplementen',
  footer_link_selfcare: 'Self-Care',
  footer_link_about: 'Over Ons',
  footer_link_blog: 'Blog',
  footer_link_consult: 'Consultaties Boeken',
  footer_link_reviews: 'Reviews & Ervaringen',
  footer_link_faq: 'Veelgestelde Vragen (FAQ)',
  footer_link_orders: 'Mijn Bestellingen',
  footer_link_contact: 'Contact',
  footer_link_shipping: 'Verzending & Retour',

  // ── Taal ──
  lang_nl: 'Nederlands',
  lang_en: 'English',
  lang_es: 'Español',

  // ── Algemene CTAs ──
  cta_planConsult: 'Plan een consult',
  cta_bookConsult: 'Boek Consult',
  cta_discoverProtection: 'Ontdek jouw bescherming',
  cta_allProducts: 'Bekijk alle beschermingsproducten',
  cta_startToday: 'Start vandaag',
  cta_viewProduct: 'Bekijk',
  cta_buyNow: 'Betaal & Boek Nu',
  cta_learnMore: 'Meer info',
  cta_shopNow: 'Shop Nu',
  cta_readMore: 'Lees meer',
  cta_back: 'Terug',
  cta_subscribe: 'Aanmelden',
  cta_bookNow: 'Boek Nu',
  cta_allArticles: 'Alle artikelen',
  cta_chooseProduct: 'Kies je Product',
  cta_askAdvice: 'Vraag Advies',
  cta_discoverSeries: 'Ontdek de Serie',
  cta_inCart: 'In Wagen',
  cta_addToCart: 'In Winkelwagen',
  cta_added: 'Toegevoegd',
  cta_add: 'Toevoegen',
  cta_viewAllProducts: 'Alle producten bekijken',
  cta_bookConsultNow: 'Boek Jouw Consult',
  cta_sendMessage: 'Verstuur Bericht',
  cta_sending: 'Versturen...',
  cta_newMessage: 'Nieuw Bericht',
  cta_backToConsult: 'Terug naar Consultaties',
  cta_inCartBtn: 'In Wagen!',
  cta_addToCartBtn: 'In Wagen',

  // ── Shop ──
  shop_title: 'Onze Collectie',
  shop_webshop_title: 'Blue Protect',
  shop_webshop_subtitle: 'Exclusieve Blue Protect beschermingsproducten',
  shop_filter_all: 'Alle Producten',
  shop_filter_blue: 'Blue Protect Serie',
  shop_filter_evil: 'Evil Energy Destroy',
  shop_filter_kit: 'Evil Energy Destroy Kit',
  shop_addToCart: 'In Winkelwagen',
  shop_inStock: 'Op Voorraad',
  shop_outOfStock: 'Uitverkocht',
  shop_perUnit: 'eenmalig',
  shop_reviews: 'beoordelingen',
  shop_search_placeholder: 'Zoek producten...',
  shop_sort_featured: 'Aanbevolen',
  shop_sort_price_asc: 'Prijs: Laag naar Hoog',
  shop_sort_price_desc: 'Prijs: Hoog naar Laag',
  shop_sort_rating: 'Hoogste Beoordeling',
  shop_categories: 'Categorieën',
  shop_max_price: 'Max Prijs',
  shop_products_found: 'producten gevonden',
  shop_no_products: 'Geen producten gevonden',
  shop_cancelled_title: 'Betaling geannuleerd',
  shop_cancelled_msg: 'Je hebt de betaling afgebroken. Je winkelwagen is bewaard — je kunt het altijd opnieuw proberen.',
  shop_blue_desc: 'Aura-reiniging & spirituele bescherming — zeep, ballen, poeder & spray.',
  shop_evil_desc: 'Krachtigste bescherming tegen kwade energieën, boze oog & spirituele aanvallen.',
  shop_kit_desc: 'Compleet doe-het-zelf pakket voor extreme gevallen — baby\'s, nieuwe ruimtes & entiteiten.',

  // ── Consultaties ──
  consult_hero_badge: '✦ Persoonlijke Begeleiding ✦',
  consult_hero_title: 'Spirituele',
  consult_hero_title2: 'Consultaties',
  consult_hero_sub: 'Persoonlijke energetische begeleiding en digitale ritueel-blauwdrukken voor diepgaande spirituele transformatie.',
  consult_tab_book: 'Consult Boeken',
  consult_tab_blueprints: 'Ritueel Blueprints',
  consult_choose: 'Kies Jouw Consult',
  consult_payment_title: 'Afspraak & Betaling',
  consult_form_first: 'Voornaam',
  consult_form_last: 'Achternaam',
  consult_form_email: 'E-mailadres',
  consult_form_phone: 'Telefoonnummer',
  consult_form_date: 'Gewenste datum',
  consult_form_date_ph: 'Kies een datum',
  consult_form_time: 'Tijdvoorkeur',
  consult_form_msg: 'Jouw vraag of situatie',
  consult_form_msg_ph: 'Vertel kort wat je hoopt te ontdekken of bereiken...',
  consult_book_btn: 'Betaal & Boek Nu',
  consult_success_title: 'Betaling Geslaagd!',
  consult_success_msg: 'Je ontvangt binnen een paar minuten een bevestiging per e-mail. We nemen contact op om de afspraak in te plannen.',
  consult_back: 'Terug naar Consultaties',
  consult_stripe_info: 'Veilig betalen met Stripe',
  consult_stripe_desc: 'Betaal direct via creditcard of iDEAL. Na betaling ontvang je een bevestiging per e-mail.',
  consult_ssl: '256-bit SSL',
  consult_stripe_footer: 'Veilig betalen via Stripe · creditcard & iDEAL',
  consult_select_first: 'Selecteer hierboven een consult type',
  consult_selected: 'Geselecteerd',
  consult_most_chosen: 'Meest Gekozen',
  consult_once: 'eenmalig',
  consult_add_cart: 'In Wagen Plaatsen',
  consult_cart_safe: 'Afrekenen via winkelwagen · veilig betalen met Stripe',
  consult_avail_hint: 'Beschikbaar op',
  consult_avail_and: '&',
  consult_no_avail: 'Geen beschikbaarheid',
  consult_no_avail_msg: 'Op deze dag zijn er geen consultaties. Kies een maandag of donderdag.',
  consult_choose_date_first: 'Kies eerst een datum om beschikbare tijden te zien',
  consult_digital_guides: '✦ Digitale Gidsen ✦',
  consult_blueprints_title: 'Ritueel Blueprints',
  consult_blueprints_sub: 'Complete digitale gidsen voor spirituele reinigingsrituelen. Direct te downloaden na aankoop via Stripe.',
  consult_stripe_safe: 'Veilig betalen met Stripe',
  consult_stripe_safe_desc: 'Na betaling ontvang je direct een downloadlink per e-mail. Beschikbaar via creditcard en iDEAL.',
  consult_digital_guide: 'Digitale Gids',
  consult_more_included: 'meer inbegrepen',
  consult_download_title: 'Direct Downloaden na Betaling',
  consult_download_desc: 'Na succesvolle betaling via Stripe ontvang je direct een e-mail met je downloadlink. De blueprints zijn in PDF-formaat en levenslang toegankelijk.',
  consult_payment_success: 'Betaling geslaagd!',
  consult_payment_success_desc: 'Je downloadlink is verstuurd naar je e-mailadres. Check ook je spam-folder.',
  consult_reviews_badge: '✦ Ervaringen ✦',
  consult_reviews_title: 'Wat Klanten',
  consult_reviews_title2: 'Zeggen',
  consult_reviews_sub: 'Echte ervaringen van mensen die de stap zetten naar een consult. Geen scripts, geen filters.',
  consult_avg_rating: 'Gemiddelde beoordeling',
  consult_reviews_count: 'Beoordelingen',
  consult_recommend: 'Zou het aanraden',
  consult_ready: 'Klaar om jouw eigen ervaring te creëren?',

  // ── Blog ──
  blog_hero_badge: '✦ Sjamanisme & Spirituele Kennis ✦',
  blog_hero_title: 'Bescherming van Jezelf,',
  blog_hero_title2: 'Je Kind en Je Omgeving',
  blog_hero_sub: 'Onrust, energieverlies, een baby die \'s nachts schrikt — soms is er meer aan de hand dan je ziet. Ontdek bewezen sjamaanse beschermingskennis voor gezin, huis en werk.',
  blog_sticky_cta: 'Plan een consult',
  blog_recognize_badge: '✦ Herken jij dit? ✦',
  blog_recognize_title: 'Soms is er meer aan de hand dan je kunt verklaren',
  blog_more: 'Meer lezen?',
  blog_read_time: 'leestijd',

  // ── Over Ons ──
  about_badge: '✦ Ons Verhaal ✦',
  about_title: 'Geworteld in',
  about_title2: 'Sjamaanse Tradities',
  about_sub: 'Persoonlijke begeleiding, authentieke beschermingsrituelen en millennia-oude kennis — voor iedereen die zijn bewustzijn wil verheffen.',

  // ── Contact ──
  contact_badge: '✦ Neem Contact Op ✦',
  contact_title: 'Contact',
  contact_sub: 'Heb je een vraag of wil je meer weten? We staan voor je klaar.',
  contact_info_title: 'Contactgegevens',
  contact_social_title: 'Volg Ons op Social Media',
  contact_form_title: 'Stuur een Bericht',
  contact_form_first: 'Voornaam *',
  contact_form_last: 'Achternaam *',
  contact_form_email: 'E-mailadres *',
  contact_form_subject: 'Onderwerp *',
  contact_form_subject_ph: 'Selecteer een onderwerp',
  contact_form_subject_product: 'Vraag over product',
  contact_form_subject_order: 'Bestelling / Verzending',
  contact_form_subject_consult: 'Consultatie informatie',
  contact_form_subject_collab: 'Samenwerking',
  contact_form_subject_other: 'Overig',
  contact_form_msg: 'Jouw bericht *',
  contact_form_msg_ph: 'Hoe kunnen we je helpen?',
  contact_form_max: 'Max. 500 tekens',
  contact_success_title: 'Bericht Verzonden!',
  contact_success_msg: 'Bedankt voor je bericht. We reageren zo snel mogelijk.',
  contact_error: 'Er is iets misgegaan. Probeer opnieuw.',

  // ── FAQ ──
  faq_badge: 'Veelgestelde Vragen',
  faq_title: 'Alles wat je wilt',
  faq_title2: 'weten',
  faq_sub: 'Antwoorden op de meest gestelde vragen over onze producten, rituelen, bestellingen en spirituele bescherming.',
  faq_questions_answered: 'Vragen beantwoord',
  faq_categories: 'Categorieën',
  faq_available: 'Beschikbaar',
  faq_questions_in_cat: 'vragen in deze categorie',
  faq_not_found_title: 'Staat jouw vraag er niet bij?',
  faq_not_found_desc: 'Neem direct contact met ons op via email of boek een persoonlijke consultatie — we helpen je graag verder.',
  faq_send_message: 'Stuur een bericht',
  faq_book_consult: 'Boek een consultatie',

  // ── Home - FeaturedProducts ──
  home_bestsellers_badge: '✦ Bestsellers ✦',
  home_bestsellers_title: 'Bestsellers',

  // ── Home - SeriesSection ──
  home_series_badge: '✦ Onze Series ✦',
  home_series_title: 'Kies Jouw',
  home_series_title2: 'Bescherming',
  home_series_sub: 'Twee series, elk voor een eigen situatie. Van dagelijkse preventie tot maximale bescherming bij zware spirituele aanvallen.',
  home_series_products: 'producten',
  home_series_reviews: 'reviews',
  home_series_not_sure: 'Weet je niet welke serie bij je past?',
  home_series_free_consult: 'Boek een gratis consult',
  home_series_help: 'en wij helpen je kiezen.',

  // ── Home - CTASection ──
  home_cta_discover_badge: '✦ Ontdek Jezelf ✦',
  home_cta_discover_title: 'Vind Je Innerlijke Balans',
  home_cta_discover_sub: 'Breng lichaam en geest in harmonie',
  home_cta_blueprint_badge: '✦ Persoonlijk Groeiplan ✦',
  home_cta_blueprint_title: 'Jouw Spirituele',
  home_cta_blueprint_title2: 'Blauwdruk',
  home_cta_blueprint_sub: 'Boek een persoonlijk consult of download onze digitale ritueel-blueprints en begin vandaag met het transformeren van je energetische leven.',
  home_cta_book_consult: 'Boek Nu een Consult',
  home_cta_blueprints: 'Ritueel Blueprints',

  // ── Home - TestimonialsSection ──
  home_test_badge: '✦ Ervaringen ✦',
  home_test_title: 'Wat Klanten Zeggen over',
  home_test_sub: 'Echte ervaringen van klanten die de kracht van puur blauw extract uit onze voorouderlijke traditie dagelijks ervaren.',
  home_test_stat1: 'Tevreden klanten',
  home_test_stat2: 'Gemiddelde beoordeling',
  home_test_stat3: 'Herhaalaankopen',
  home_test_stat4: 'Jaren traditie',

  // ── Home - FeaturedCategories ──
  home_cat_badge: '✦ Collecties ✦',
  home_cat_title: 'Ontdek Onze',
  home_cat_title2: 'Collecties',
  home_cat_new: 'Nieuw',

  // ── Home - BlogPreview ──
  home_blog_badge: '✦ Blog ✦',
  home_blog_title: 'Spirituele',
  home_blog_title2: 'Inzichten',

  // ── Home - InstagramSection ──
  home_insta_title: 'Volg ons op',
  home_insta_title2: 'Instagram',
  home_insta_sub: 'Dagelijkse rituelen, producttips en spirituele inspiratie. Tag ons met',
  home_insta_sub2: 'en word featured!',
  home_insta_hashtags_title: 'Gebruik deze hashtags',
  home_insta_hashtags_sub: '— vergroot je bereik',
  home_insta_copy_all: 'Kopieer alle hashtags',
  home_insta_copied: 'Alle gekopieerd!',
  home_insta_copied_tag: 'Gekopieerd!',
  home_insta_follow: 'Volg @zpiritualz',
  home_insta_ugc: 'klanten deelden hun ervaring — tag ons en word featured op onze pagina!',

  // ── Home - TikTokSection ──
  home_tiktok_title: 'Volg ons op',
  home_tiktok_title2: 'TikTok',
  home_tiktok_sub: 'Dagelijkse rituelen, productdemo\'s en spirituele tips. Sluit je aan bij onze groeiende community van',
  home_tiktok_sub2: 'volgers die hun energie beschermen.',
  home_tiktok_followers: 'Volgers',
  home_tiktok_likes: 'Likes',
  home_tiktok_views: 'Views',
  home_tiktok_no_miss: 'Mis geen enkel ritueel',
  home_tiktok_no_miss_sub: 'Elke week nieuwe video\'s over spirituele bescherming, productdemo\'s en rituelen. Volg ons nu en zet de notificaties aan!',
  home_tiktok_follow: 'Volg @zpiritualz.com',
  home_tiktok_notify: 'Zet notificaties aan',

  // ── Blue Protect pagina ──
  bp_cultural_badge: '✦ Oorsprong & Cultuur ✦',
  bp_cultural_title: 'Eeuwenoud gebruik,',
  bp_cultural_title2: 'moderne vorm',
  bp_cultural_desc1: 'Blauw poeder wordt al duizenden jaren gebruikt in Surinaamse en andere wereldculturen voor bescherming tegen het boze oog — Ogri Ai in het Surinaams, Nazar bij Hindoestanen, Azul in de Spaanse traditie.',
  bp_cultural_desc2: 'Blue Protect bewaart dit erfgoed in zijn puurste vorm. Het indigofera-extract wordt gewonnen precies zoals onze voorouders dat deden — handmatig, zonder chemische verwerkingsstappen, met respect voor de traditie.',
  bp_heritage: 'Surinaamse Erfenis',
  bp_test_badge: '✦ Ervaringen ✦',
  bp_test_title: 'Wat Klanten',
  bp_test_title2: 'Zeggen',
  bp_cross_badge: 'Voor zwaardere gevallen',
  bp_cross_title: 'Ook de',
  bp_cross_title2: 'Evil Energy Destroy Serie',
  bp_cross_title3: 'ontdekken?',
  bp_cross_desc: 'Bij zware spirituele aanvallen, hardnekkige kwade energieën of herhaalblootstelling — de Evil Energy Destroy Serie is onze krachtigste formule.',
  bp_cross_btn: 'Bekijk Evil Energy Protect',
  bp_cta_badge: '✦ Begin Vandaag ✦',
  bp_cta_title: 'Jouw Bescherming',
  bp_cta_title2: 'Begint Hier',
  bp_cta_sub: 'Stap in een eeuwenoude beschermingstraditie. Puur, authentiek en krachtig — precies zoals onze voorouders het bedoelden.',
  bp_cta_choose: 'Kies je Product',
  bp_cta_advice: 'Vraag Advies',
  bp_cta_pure: '100% Puur Indigofera-extract',
  bp_cta_fast: 'Snel Verzonden',
  bp_cta_safe: 'Veilig Bestellen',
  bp_nav_products: 'Producten',
  bp_nav_rituals: 'Rituelen',
  bp_nav_ingredients: 'Ingrediënten',

  // ── Evil Energy pagina ──
  ee_test_badge: '✦ Ervaringen ✦',
  ee_test_title: 'Wat Klanten',
  ee_test_title2: 'Zeggen',
  ee_cta_badge: '✦ Klaar voor Bescherming ✦',
  ee_cta_title: 'Jouw Bescherming',
  ee_cta_title2: 'Begint Vandaag',
  ee_cta_sub: 'Wacht niet tot de situatie erger wordt. De Evil Energy Destroy Serie staat klaar om je te beschermen met de kracht van eeuwenoude tradities en de puurste ingrediënten.',
  ee_cta_choose: 'Kies je Product',
  ee_cta_advice: 'Vraag Advies',
  ee_cta_pure: '100% Puur Natuurlijk',
  ee_cta_fast: 'Snel Verzonden',
  ee_cta_safe: 'Veilig Bestellen',
  ee_nav_products: 'Producten',
  ee_nav_bundle: 'Ritueel Bundel',
  ee_nav_rituals: 'Rituelen',
  ee_nav_ingredients: 'Ingrediënten',

  // ── About pagina ──
  about_hero_title: 'De Kracht Achter ZpiritualZ',
  about_founded: 'Opgericht',
  about_tradition: 'Jaar traditie',
  about_households: 'Beschermde huishoudens',
  about_story_badge: '✦ Hoe Het Begon ✦',
  about_story_title: 'Een Persoonlijke Ervaring Die Alles Veranderde',
  about_story_p1: 'ZpiritualZ ontstond niet vanuit een spreadsheet of een marketingplan — het ontstond vanuit een persoonlijke crisis. Na een periode van aanhoudende negativiteit, onrust thuis en een gevoel dat er iets niet klopte in de energie van de omgeving, keerde de oprichtster terug naar wat haar oma haar had geleerd: hing branden, hing onder het kussen, hing in het badwater.',
  about_story_p2: 'De verandering was voelbaar. Niet als magie — maar als herkenning. Als thuiskomen bij kennis die altijd al in de familie aanwezig was, maar die generaties lang was meegegeven zonder uitleg. ZpiritualZ is opgericht om die kennis terug te geven aan iedereen die haar nodig heeft.',
  about_story_p3: 'Vandaag vertalen we eeuwenoude sjamaanse beschermingstradities naar producten die in het dagelijks leven passen: in de badkamer, in de slaapkamer, in de kinderkamer — overal waar bescherming nodig is.',
  about_ingredient_label: 'Kerningredient',
  about_ingredient_name: 'Ferula asafoetida',
  about_ingredient_sub: 'Puur hing-extract · Iranees & Indiaas',
  about_sham_origin: '✦ De Oorsprong van Alles ✦',
  about_sham_title: 'Sjamanisme is de Bron',
  about_sham_desc: 'Sjamanisme is een van de oudste spirituele praktijken ter wereld en heeft zijn wortels in inheemse tradities en culturen over de hele wereld. Sjamanen zijn de brugbouwers tussen de zichtbare en onzichtbare wereld — de beschermers, geneeskundigen en gidsen van hun gemeenschap.',
  about_sham_worldwide: 'Wereldwijd aanwezig',
  about_sham_worldwide_desc: 'Van Siberië tot de Amazone, van West-Afrika tot Oceanië — sjamanisme is de universele spirituele taal van de mensheid.',
  about_sham_age: '40.000+ jaar oud',
  about_sham_age_desc: 'Ouder dan alle georganiseerde religies. De wortels van sjamanisme reiken terug tot de eerste mensen die vuur maakten en de sterren bestudeerden.',
  about_sham_plants: 'Planten als sleutel',
  about_sham_plants_desc: 'Heilige planten en harsen — zoals hing, salie en lobhan — zijn de instrumenten van de sjamaan voor reiniging, bescherming en genezing.',
  about_sham_caption: 'Sjamanisme · Wereldwijde Wijsheid',
  about_sham_caption_sub: 'Elke cultuur, elk continent — de sjamaan is universeel aanwezig als beschermer van de gemeenschap.',
  about_hing_badge: '✦ De Oorsprong ✦',
  about_hing_title: 'De Hing-Traditie: 2.000 Jaar Bescherming',
  about_hing_sub: 'Hing — de hars van de Ferula asafoetida plant — is een van de oudste spirituele en medicinale grondstoffen ter wereld. Van Iran tot India, van India tot Suriname, van Suriname tot Nederland.',
  about_hing_origin: 'Afkomstig uit Iran & India',
  about_hing_origin_desc: 'Ferula asafoetida groeit in de woestijnen van Centraal-Azië. De hars wordt al meer dan 2.000 jaar gebruikt in Perzische, Indiase en Surinaamse tradities.',
  about_hing_protector: 'Beschermer van het Huis',
  about_hing_protector_desc: 'In Hindoestaanse huishoudens wordt hing al generaties lang gebruikt om het huis, de baby en de slaapkamer te beschermen tegen slechte ogen en negatieve energieën.',
  about_hing_smoke: 'Gereinigd door Rook',
  about_hing_smoke_desc: 'Het branden van hing als wierook reinigt de energie van een ruimte. De geur doordringt elke hoek en verdrijft wat niet thuis hoort in de ruimte.',
  about_hing_baby: 'Bescherming van de Baby',
  about_hing_baby_desc: 'Al eeuwenlang wordt hingpasta in de haren van pasgeborenen of onder het kussen gesmeerd — een liefdevol ritueel dat moeder aan kind doorgeeft.',
  about_hing_quote: '"Hing gaat niet verloren — het reist mee. Van de Indiase hoogvlakten naar de Surinaamse savannes, van de savannes naar de Nederlandse wijken. De kennis leeft."',
  about_hing_journey: 'De Reis van Hing door de Wereld',
  about_timeline_badge: '✦ Tijdlijn ✦',
  about_timeline_title: 'Van Eeuwenoude Traditie tot Modern Merk',
  about_philosophy_badge: '✦ Filosofie ✦',
  about_philosophy_title: 'Wat Wij Geloven',
  about_philosophy_sub: 'ZpiritualZ is meer dan een productenreeks — het is een filosofie van bescherming, bewustzijn en cultureel erfgoed.',
  about_phil_roots: 'Wortels Respecteren',
  about_phil_roots_desc: 'Onze producten zijn niet uitgevonden — ze zijn herontdekt. We halen de wijsheid van voorouders terug naar de moderne wereld zonder de essentie te verliezen.',
  about_phil_pure: 'Puur & Onverdund',
  about_phil_pure_desc: 'Geen goedkope vulstoffen. Geen synthetische maskers. Elk product bevat een eerlijk percentage puur hing-extract, zoals de traditie het voorschrijft.',
  about_phil_sham: 'Sjamaanse Kennis',
  about_phil_sham_desc: 'Sjamanisme is een van de oudste spirituele praktijken ter wereld — geworteld in inheemse tradities en culturen over de hele wereld. ZpiritualZ put uit deze tijdloze bron.',
  about_phil_ritual: 'Rituelen voor Iedereen',
  about_phil_ritual_desc: 'Of je nou een nieuwe moeder bent, op zoek bent naar huisreiniging of gewoon bescherming wil — onze producten zijn toegankelijk en praktisch in dagelijks gebruik.',
  about_quote: '"Elk product dat wij maken is een gebed. Een herinnering aan wat onze voorouders wisten: dat bescherming begint met geur, met intentie, met ritueel."',
  about_cta_badge: '✦ Ontdek de Producten ✦',
  about_cta_title: 'Klaar om je Huis te Beschermen?',
  about_cta_sub: 'Ontdek onze Evil Energy Destroy Serie — zes producten gebaseerd op puur hing-extract, voor dagelijkse bescherming thuis, voor baby en voor ruimte.',
  about_cta_ee: 'Evil Energy Destroy Serie',
  about_cta_shop: 'Alle Producten',

  // ── Contact pagina ──
  contact_address: 'Adres',
  contact_email_label: 'E-mail',
  contact_hours: 'Openingstijden',
  contact_reach: 'Bereikbaarheid',
  contact_address_val: 'Kobaltstraat 21, 2544 ET Den Haag, Nederland',
  contact_email_val: 'info@zpiritualz.com',
  contact_hours_val: 'Ma t/m Za: 10:00–17:00',
  contact_reach_val: 'Wij zijn uitsluitend bereikbaar via e-mail',
  contact_map_title: 'ZpiritualZ locatie Den Haag',
  contact_form_ph_first: 'Luna',
  contact_form_ph_last: 'de Vries',
  contact_form_ph_email: 'jij@email.nl',
  contact_form_ph_msg: 'Hoe kunnen we je helpen?',

  // ── FAQ pagina ──
  faq_cat_general: 'Algemeen',
  faq_cat_blue: 'Blue Protect Serie',
  faq_cat_evil: 'Evil Energy Destroy Serie',
  faq_cat_kit: 'Evil Energy Destroy Kit',
  faq_cat_blueprints: 'Ritueel Blueprints',
  faq_cat_consult: 'Consultaties',
  faq_questions_in_cat_label: 'vragen in deze categorie',

  // ── Shop pagina ──
  shop_hero_title: 'Blue Protect',
  shop_hero_subtitle: 'Webwinkel',
  shop_hero_desc: 'Exclusieve Blue Protect beschermingsproducten',
  shop_filter_label: 'Categorieën',
  shop_price_label: 'Max Prijs',
  shop_in_stock: 'Op voorraad',
  shop_cancelled_close: 'Sluiten',

  // ── Blue Protect Hero ──
  bp_hero_badge: 'Eeuwenoude Bescherming',
  bp_hero_title: 'Blue Protect Serie',
  bp_hero_sub: 'Gebaseerd op een eeuwenoud gebruik van blauw poeder voor spirituele bescherming — geworteld in Surinaamse cultuur en wereldwijd erkend.',
  bp_hero_pure: 'Puur indigofera-extract, precies zoals onze voorouders het gebruikten. Geen synthetische toevoegingen. Nooit.',
  bp_hero_surinamese: 'Surinaams',
  bp_hero_hindustani: 'Hindoestaans',
  bp_hero_spanish: 'Spaans',
  bp_hero_view_products: 'Bekijk Producten',
  bp_hero_discover: 'Ontdek de Formule',
  bp_hero_stat1: 'Producten in de Serie',
  bp_hero_stat2: 'Gemiddelde Beoordeling',
  bp_hero_stat3: 'Klantreviews',
  bp_hero_stat4: 'Puur Indigofera-extract',

  // ── Blue Protect Ingredients ──
  bp_ing_badge: '✦ Puur uit de Natuur ✦',
  bp_ing_title: 'De Ingrediënten',
  bp_ing_sub: 'Elk ingrediënt in de Blue Protect Serie is puur gewonnen uit de natuur — precies zoals onze voorouders het eeuwenlang gebruikten, zonder tussenkomst van chemische processen.',
  bp_ing_promise_badge: 'Onze Belofte',
  bp_ing_promise_title: 'Alleen puur indigofera-extract. Geen synthetische namaak. Nooit.',
  bp_ing_promise_desc: 'Veel concurrenten gebruiken synthetische blauwe kleurstoffen als goedkoop alternatief. Wij weigeren dit. Ons blauw komt uitsluitend van de indigofera plant — net zoals het bij de bron gewonnen wordt.',
  bp_ing_name: 'Puur Indigofera-extract',
  bp_ing_latin: 'Indigofera tinctoria',
  bp_ing_desc: 'Het hart van de Blue Protect formule. Indigofera is een heilige plant die al duizenden jaren wordt gebruikt in spirituele beschermingsrituelen wereldwijd. Het diepe blauwe extract wordt rechtstreeks van de plant gewonnen — puur, ongefilterd en onbewerkt.',
  bp_ing_origin: 'Zuid-Azië & West-Afrika — de oudste bekende beschermende kleurstof ter wereld',
  bp_ing_found_in: 'Aanwezig in alle producten',
  bp_ing_balls_badge: '✦ Uniek Kenmerk ✦',
  bp_ing_balls_title: 'Blue Protect Balls — Oplossen is de Kracht',
  bp_ing_balls_sub: 'Wat de Balls uniek maakt ten opzichte van de andere producten in de serie: ze zijn speciaal gemaakt om op te lossen in water. Zo geeft het extract zich volledig vrij — in bad of als beschermend glas in de hoeken van je ruimte.',
  bp_ing_balls_f1_title: 'Oplost volledig in water',
  bp_ing_balls_f1_desc: 'De bal lost langzaam op en geeft het puur indigofera-extract geleidelijk vrij — in bad of in een glas water.',
  bp_ing_balls_f2_title: 'Glas water in de hoeken',
  bp_ing_balls_f2_desc: 'Zet een opgeloste bal in een glas water met een scheutje Evil Energy Destroy Cologne en plaats in de hoeken van ruimtes voor constante bescherming.',
  bp_ing_balls_f3_title: 'Diepe badreinigng',
  bp_ing_balls_f3_desc: 'Los een bal op in warm badwater voor een diepe energetische reiniging van het volledige lichaam — het extract verspreidt zich gelijkmatig door het water.',
  bp_ing_balls_f4_title: '100% puur en natuurlijk',
  bp_ing_balls_f4_desc: 'Geen synthetische bindmiddelen of vulstoffen — de bal bestaat uitsluitend uit puur indigofera-extract dat volledig oplost zonder residu.',
  bp_ing_how_badge: 'Hoe het werkt',
  bp_ing_how_title: 'Zodra de bal in contact komt met water begint het indigofera-extract vrij te komen — het water kleurt diepblauw en is klaar voor gebruik.',
  bp_ing_how_f1: 'Volledig oplosbaar — geen residu',
  bp_ing_how_f2: 'Werkt in bad én in een glas water',
  bp_ing_how_f3: 'Combineer met Evil Energy Destroy Cologne',

  // ── Blue Protect Products ──
  bp_prod_badge: '✦ De Collectie ✦',
  bp_prod_title: '4 Producten, 1 Missie',
  bp_prod_sub: 'Elke formule in de Blue Protect Serie is gericht op een specifieke toepassingsmethode — samen vormen ze een complete spirituele beschermingslaag.',
  bp_prod_series: 'Blue Protect Serie',
  bp_prod_in_stock: 'Op voorraad',
  bp_prod_tab_desc: 'Omschrijving',
  bp_prod_tab_ing: 'Ingrediënten',
  bp_prod_tab_use: 'Gebruik',
  bp_prod_tab_reviews: 'Reviews',
  bp_prod_ing_title: 'Ingrediënten',
  bp_prod_ing_pure: 'Alle ingrediënten zijn 100% puur van oorsprong — geen synthetische toevoegingen, vulstoffen of chemische derivaten.',
  bp_prod_use_title: 'Gebruiksaanwijzing',
  bp_prod_overview: 'Volledige Serie Overzicht',
  bp_prod_add_cart: 'In Wagen',

  // ── Blue Protect Rituals ──
  bp_rit_badge: '✦ Heilige Praktijken ✦',
  bp_rit_title: 'Beschermingsrituelen',
  bp_rit_sub: 'De Blue Protect producten zijn het krachtigst wanneer ze bewust als ritueel worden toegepast — precies zoals onze voorouders dat generaties lang deden.',
  bp_rit_duration: 'Tijdsduur',
  bp_rit_level: 'Niveau',
  bp_rit_products: 'Benodigde Producten',
  bp_rit_steps: 'Stap-voor-stap',
  bp_rit_tip: 'Tip',
  bp_rit1_title: 'Dagelijkse Aura-Reiniging',
  bp_rit1_sub: 'Preventieve ochtendroutine',
  bp_rit1_duration: '8 minuten',
  bp_rit1_level: 'Beginners',
  bp_rit1_tip: 'Gebruik dit ritueel elke ochtend als preventie, ook als je geen directe klachten ervaart.',
  bp_rit2_title: 'Spiritueel Reinigingsbad',
  bp_rit2_sub: 'Diepe energetische reset',
  bp_rit2_duration: '30–40 minuten',
  bp_rit2_level: 'Beginner',
  bp_rit2_tip: 'Doe dit ritueel bij voorkeur op vrijdag of bij de volle maan voor maximale reinigingswerking.',
  bp_rit3_title: 'Huisreinigingsritueel',
  bp_rit3_sub: 'Bescherm je woning volledig',
  bp_rit3_duration: '15–20 minuten',
  bp_rit3_level: 'Beginners',
  bp_rit3_tip: 'Herhaal dit ritueel wekelijks, of direct nadat er conflicten of veel bezoekers zijn geweest.',
  bp_rit4_title: 'Bescherming Kwetsbaren',
  bp_rit4_sub: 'Voor kinderen & zwangere vrouwen',
  bp_rit4_duration: '5 minuten',
  bp_rit4_level: 'Beginners',
  bp_rit4_tip: 'Kinderen en zwangere vrouwen zijn volgens de overlevering het meest kwetsbaar voor het boze oog. Regelmatige bescherming is essentieel.',

  // ── Evil Energy Hero ──
  ee_hero_badge: 'Maximale Bescherming',
  ee_hero_title: 'Evil Energy Destroy Serie',
  ee_hero_sub: 'Voor wie kampt met zware spirituele aanvallen, hardnekkige kwade energieën of herhaalblootstelling aan het boze oog — wanneer gewone bescherming niet meer volstaat.',
  ee_hero_pure: 'Gebaseerd op het zwaarste beschermingsrecept van onze voorouders. Puur, krachtig, onvervuild.',
  ee_hero_view: 'Bekijk Producten',
  ee_hero_discover: 'Ontdek de Formule',
  ee_hero_stat1: 'Producten in de Serie',
  ee_hero_stat2: 'Gemiddelde Beoordeling',
  ee_hero_stat3: 'Klantreviews',
  ee_hero_stat4: 'Puur Hing-extract',

  // ── Evil Energy Ingredients ──
  ee_ing_badge: '✦ Het Kerningredient ✦',
  ee_ing_title: 'De Kracht van Hing',
  ee_ing_sub: 'Alle zes producten in de Evil Energy Destroy Serie zijn opgebouwd rondom één krachtig kerningredient: puur hing-extract (Ferula asafoetida) — het sterkste afwerende middel dat de natuur kent.',
  ee_ing_promise_badge: 'Onze Belofte',
  ee_ing_promise_title: 'Puur hing. Niets anders. Geen synthetische namaak. Nooit.',
  ee_ing_promise_desc: 'Terwijl veel andere merken goedkope synthetische geurstoffen gebruiken als vervanging, weigeren wij dit. Onze hing is 100% puur gewonnen uit de wortel van de Ferula asafoetida plant — precies zoals onze voorouders het gebruikten.',
  ee_ing_name: 'Hing (Asafoetida)',
  ee_ing_latin: 'Ferula asafoetida',
  ee_ing_desc: 'Hing — ook wel duivelsdrek of asafoetida genoemd — is het meest krachtige afwerende middel in de Surinaamse, Hindoestaanse en Zuid-Aziatische beschermingstraditie. De scherpe, doordringende geur van hing is in staat om kwade geesten, negatieve intenties en het boze oog direct te verdrijven. Waar hing aanwezig is, kan kwaad niet gedijen.',
  ee_ing_origin: 'Iran, Afghanistan & India — al duizenden jaren gebruikt als heilig beschermingsmiddel in meerdere wereldculturen',
  ee_ing_found_in: 'Aanwezig in alle 6 producten',
  ee_ing_surinamese: 'Surinaamse traditie',
  ee_ing_surinamese_text: 'In de Surinaamse cultuur wordt hing al generaties lang gebruikt om baby\'s en kwetsbaren te beschermen. Een klein beetje hing in de haren of onder het kussen van een baby houdt het boze oog weg.',
  ee_ing_hindustani: 'Hindoestaanse traditie',
  ee_ing_hindustani_text: 'Hing — ook wel "heeng" of "inguva" — wordt in Hindoestaanse beschermingsrituelen gebruikt om kwade geesten en negatieve energieën te verjagen. Het branden van hing reinigt een ruimte volledig.',
  ee_ing_worldwide: 'Wereldwijde erkenning',
  ee_ing_worldwide_text: 'Van het Midden-Oosten tot Centraal-Azië: hing wordt in meerdere culturen erkend als een van de krachtigste afwerende middelen die de natuur kent. De geur alleen al verdrijft kwaad.',

  // ── Evil Energy Rituals ──
  ee_rit_badge: '✦ Heilige Praktijken ✦',
  ee_rit_title: 'Beschermingsrituelen',
  ee_rit_sub: 'Elk product in de Evil Energy Destroy Serie heeft een eigen toepassingsritueel. Combineer ze voor een complete, meervoudige bescherming van lichaam en huis.',
  ee_rit_duration: 'Tijdsduur',
  ee_rit_level: 'Niveau',
  ee_rit_products: 'Benodigde Producten',
  ee_rit_steps: 'Stap-voor-stap',
  ee_rit_tip: 'Tip',
  ee_rit1_title: 'Dagelijks Badritueel',
  ee_rit1_sub: 'Bescherming van lichaam & aura',
  ee_rit1_duration: '15–20 minuten',
  ee_rit1_level: 'Beginners',
  ee_rit1_tip: 'Gebruik elke dag voor aanhoudende bescherming. Bij zware gevallen: twee keer daags.',
  ee_rit2_title: 'Baby Bescherming',
  ee_rit2_sub: 'Dag & nacht veilig voor je kleintje',
  ee_rit2_duration: '2 minuten',
  ee_rit2_level: 'Beginners',
  ee_rit2_tip: 'Herhaal elke dag. Na een bezoek van veel mensen of in drukke omgevingen: pas het aan direct bij thuiskomst.',
  ee_rit3_title: 'Huis Reinigingsritueel',
  ee_rit3_sub: 'Verjaag kwade energieën uit elke ruimte',
  ee_rit3_duration: '20–30 minuten',
  ee_rit3_level: 'Beginners',
  ee_rit3_tip: 'Doe dit wekelijks of direct na bezoek van mensen die een zware sfeer meebrengen.',
  ee_rit4_title: 'Kaars & Indamp Ritueel',
  ee_rit4_sub: 'Continue bescherming via geur en licht',
  ee_rit4_duration: '5 minuten voorbereiding',
  ee_rit4_level: 'Beginners',
  ee_rit4_tip: 'Brandende hing-olie in de slaapkamer beschermt ook tijdens de slaap. Gebruik nooit zonder toezicht.',
  ee_rit5_title: 'Huis Dweilen',
  ee_rit5_sub: 'Bescherming van de grond af opbouwen',
  ee_rit5_duration: '20 minuten',
  ee_rit5_level: 'Beginners',
  ee_rit5_tip: 'Wekelijks dweilen met Cologne houdt het huis continu beschermd. Ideaal als aanvulling op het wierookritueel.',

  // ── Evil Energy Bundle ──
  ee_bundle_badge: '✦ Aanbevolen Combinatie ✦',
  ee_bundle_title: 'De Dagelijkse Ritueel Bundel',
  ee_bundle_sub: 'Voor maximale bescherming combineer je de Evil Energy Destroy Zeep met de Cologne in één dagelijks badritueel. Samen vormen zij een complete energetische reinigingscyclus die evil energy actief verbreekt, vernietigt en wegdraagt.',
  ee_bundle_step1: 'Stap 1',
  ee_bundle_step2: 'Stap 2',
  ee_bundle_ritual_title: 'Het Dagelijkse Badritueel',
  ee_bundle_ritual_sub: 'Stap-voor-stap complete beschermingscyclus',
  ee_bundle_ritual_note: 'Belangrijk ritueel detail',
  ee_bundle_ritual_note_desc: 'Gooi de fles achterover zonder om te kijken. Het omdraaien om te kijken breekt de energetische overdracht en kan de bescherming verminderen. Voer het ritueel bij voorkeur in de ochtend uit voor een dag vol bescherming.',
  ee_bundle_cta_badge: 'Aanbevolen Dagelijks Pakket',
  ee_bundle_cta_title: 'Zeep + Cologne Bundel',
  ee_bundle_cta_sub: 'Beide producten samen — compleet voor het dagritueel',
  ee_bundle_label: 'Bundel',
  ee_bundle_add: 'Bundel in Wagen',
  ee_bundle_all: 'Bekijk Alle Producten',
  ee_bundle_pure: '100% Puur Natuurlijk',
  ee_bundle_daily: 'Dagelijks Gebruik',
  ee_bundle_proven: 'Bewezen Ritueel',
  ee_bundle_step1_title: 'Bad vullen',
  ee_bundle_step1_desc: 'Vul het bad met warm water en voeg een flinke scheut Evil Energy Destroy Cologne toe aan het badwater. Roer met je hand drie keer met de klok mee.',
  ee_bundle_step2_title: 'Lichaam wassen',
  ee_bundle_step2_desc: 'Was je lichaam met de Evil Energy Destroy Zeep. Laat het mengsel van cologne en zeep over je gehele lichaam stromen.',
  ee_bundle_step3_title: 'Mengsel opvangen',
  ee_bundle_step3_desc: 'Vang het water dat over je lichaam is gegaan op in een lege fles. Dit water heeft de kwade energieën opgenomen.',
  ee_bundle_step4_title: '5 Cent toevoegen',
  ee_bundle_step4_desc: 'Voeg een 5 cent munt toe aan de fles en sluit hem goed af. De munt versterkt de overdracht van negatieve energie.',
  ee_bundle_step5_title: 'Fles in de zee',
  ee_bundle_step5_desc: 'Gooi de fles achterover in de zee — zonder om te kijken. Het zeewater draagt de kwade energieën definitief weg.',

  // ── EDK Hero ──
  edk_hero_badge: 'Extreme Gevallen · Doe Het Zelf Kit',
  edk_hero_title: 'Evil Energy Destroy Kit Compleet!',
  edk_hero_sub: 'Voor de zwaarste gevallen — wanneer het schoonmaken van een ruimte niet genoeg is en de kwade energie vernietigd moet worden. Een compleet pakket met alles wat je nodig hebt.',
  edk_hero_pure: 'Inclusief professionele Blueprint · Speciale kruidenwierookmix · Complete rituele materialen',
  edk_hero_complete: 'Compleet pakket',
  edk_hero_discover: 'Ontdek Wanneer Je Dit Nodig Hebt',
  edk_hero_stat1: 'Items in het Pakket',
  edk_hero_stat2: 'Situaties Gedekt',
  edk_hero_stat3: 'Puur Natuurlijk',
  edk_hero_stat4: 'Gemiddelde Beoordeling',
  edk_hero_added: 'Toegevoegd aan wagen!',
  edk_hero_add: 'In Wagen',

  // ── EDK Contents ──
  edk_contents_badge: '✦ Wat Zit Er In Het Pakket? ✦',
  edk_contents_title: 'Het Complete Arsenal',
  edk_contents_sub: 'Alles wat je nodig hebt om kwade energieën te vernietigen. Zorgvuldig samengesteld door ZpiritualZ — niets meer nodig, niets minder.',
  edk_contents_summary: '10 Items · 1 Complete Kit',
  edk_contents_summary_sub: 'Alles wat je nodig hebt voor het destructieritueel',
  edk_contents_blueprint_title: 'Blueprint Inbegrepen',
  edk_contents_blueprint_sub: 'De geheime handleiding — exclusief bij dit pakket',
  edk_contents_blueprint_p1: 'Zonder de juiste kennis zijn de beste materialen niets. De Blueprint is de handleiding die je stap voor stap door het volledige destructieritueel leidt. Welke volgorde, welk materiaal op welk moment, welke intentie je neerzet.',
  edk_contents_blueprint_p2: 'De Blueprint is exclusief ontwikkeld door ZpiritualZ en is alleen verkrijgbaar als onderdeel van de Destroy Kit. Je krijgt hem direct bij aankoop.',
  edk_contents_pure: '100% Puur Natuurlijk',
  edk_contents_no_synth: 'Geen Synthetische Toevoegingen',
  edk_contents_ancient: 'Eeuwenoude Formule',
  edk_contents_guaranteed: 'ZpiritualZ Gegarandeerd',

  // ── EDK Problems ──
  edk_prob_badge: '✦ Voor Wie Is Dit Pakket? ✦',
  edk_prob_title: 'Herken Jij Jouw Situatie?',
  edk_prob_sub: 'De Destroy Kit is ontwikkeld voor drie specifieke, ernstige situaties. Lees welke het meest op jouw situatie lijkt.',
  edk_prob_symptoms: 'Herkenbare Signalen',
  edk_prob_order: 'Bestel de Destroy Kit',

  // ── EDK Purchase ──
  edk_purch_test_badge: '✦ Ervaringen ✦',
  edk_purch_test_title: 'Dit Zeggen Onze Klanten',
  edk_purch_cta_badge: '✦ Doe Het Nu ✦',
  edk_purch_cta_title: 'Vernietig De Kwade Energie Voor Altijd',
  edk_purch_cta_sub: 'Stop met accepteren wat je niet hoeft te accepteren. Met de juiste kennis en materialen kan jij dit zelf aanpakken — vandaag.',
  edk_purch_kit_name: 'Evil Energy Destroy Kit Compleet',
  edk_purch_includes: 'Inclusief Blueprint, Wierookmix & Complete Rituele Set',
  edk_purch_blueprint: 'Blueprint Inbegrepen',
  edk_purch_herbs: 'Speciale Kruidenmix',
  edk_purch_shell: 'Abalone Schelp + Veer',
  edk_purch_coal: 'Brandkool + Kaars',
  edk_purch_added: 'Toegevoegd aan wagen!',
  edk_purch_add: 'In Wagen',
  edk_purch_pure: '100% Puur Natuurlijk',
  edk_purch_fast: 'Snel Verzonden',
  edk_purch_worldwide: 'Wereldwijde Verzending',
  edk_purch_guarantee: 'ZpiritualZ Garantie',
  edk_purch_safe: 'Veilig betalen via Stripe · creditcard & iDEAL',

  // ── BPProducts ──
  bp_prod_in_stock_label: 'Op voorraad',
  bp_prod_add_cart_btn: 'In Wagen',
  bp_prod_ing_label: 'Ingrediënten',
  bp_prod_use_label: 'Gebruiksaanwijzing',
  bp_prod_series_label: 'Blue Protect Serie',
  bp_prod_overview_label: 'Volledige Serie Overzicht',
  bp_prod_ing_pure_note: 'Alle ingrediënten zijn 100% puur van oorsprong — geen synthetische toevoegingen, vulstoffen of chemische derivaten.',

  // ── EDKContents ──
  edk_cont_badge: '✦ Wat Zit Er In Het Pakket? ✦',
  edk_cont_title: 'Het Complete Arsenal',
  edk_cont_sub: 'Alles wat je nodig hebt om kwade energieën te vernietigen. Zorgvuldig samengesteld door ZpiritualZ — niets meer nodig, niets minder.',
  edk_cont_summary: '10 Items · 1 Complete Kit',
  edk_cont_summary_sub: 'Alles wat je nodig hebt voor het destructieritueel',
  edk_cont_old_price: '€99,95',
  edk_cont_price: '€79,95',
  edk_cont_blueprint_title: 'Blueprint Inbegrepen',
  edk_cont_blueprint_sub: 'De geheime handleiding — exclusief bij dit pakket',
  edk_cont_blueprint_p1: 'Zonder de juiste kennis zijn de beste materialen niets. De Blueprint is de handleiding die je stap voor stap door het volledige destructieritueel leidt. Welke volgorde, welk materiaal op welk moment, welke intentie je neerzet.',
  edk_cont_blueprint_p2: 'De Blueprint is exclusief ontwikkeld door ZpiritualZ en is alleen verkrijgbaar als onderdeel van de Destroy Kit. Je krijgt hem direct bij aankoop.',
  edk_cont_pure: '100% Puur Natuurlijk',
  edk_cont_no_synth: 'Geen Synthetische Toevoegingen',
  edk_cont_ancient: 'Eeuwenoude Formule',
  edk_cont_guaranteed: 'ZpiritualZ Gegarandeerd',
  edk_cont_item1_name: 'Exclusieve Blueprint',
  edk_cont_item1_desc: 'Stap-voor-stap handleiding van ZpiritualZ voor het volledige destructieritueel. Welke stappen, in welke volgorde, met welk materiaal. Niets aan het toeval overgelaten.',
  edk_cont_item1_tag: 'Inbegrepen',
  edk_cont_item2_name: 'Speciale Kruidenwierookmix',
  edk_cont_item2_desc: 'Onze exclusieve mix van salie-kruidenextracten, ghandak, pepper, hing en lobhan. Een eigen betrouwbare formule met bewezen werking — bijzonder krachtig voor het vernietigen van kwade energieën.',
  edk_cont_item2_tag: 'Eigen Mix',
  edk_cont_item3_name: 'Salie Kruiden Extracten',
  edk_cont_item3_desc: 'Puur gedroogde salie — het meest gebruikte reinigingskruid in de wereld. Reinigt de aura en de ruimte van alle negatieve energie na verbranding.',
  edk_cont_item3_tag: 'Kruid',
  edk_cont_item4_name: 'Ghandak (Zwavel)',
  edk_cont_item4_desc: 'Een van de oudste en krachtigste beschermende middelen. Ghandak vernietigt hardnekkige kwade energieën en entiteiten die andere reinigingsmiddelen overleven.',
  edk_cont_item4_tag: 'Vernietigend',
  edk_cont_item5_name: 'Pepper & Hing',
  edk_cont_item5_desc: 'Zwarte peper combineert met hing (asafoetida) voor een dubbele beschermingslinie. Samen vormen ze een energetische muur die negatieve invloeden verdrijft en vernietigt.',
  edk_cont_item5_tag: 'Dubbele Kracht',
  edk_cont_item6_name: 'Lobhan (Benzoe)',
  edk_cont_item6_desc: 'Traditioneel Arabisch-Surinaams reinigingshars. Lobhan reinigt diep op spiritueel niveau en beschermt de ruimte na het reinigingsritueel.',
  edk_cont_item6_tag: 'Hars',
  edk_cont_item7_name: 'Abalone Schelp',
  edk_cont_item7_desc: 'De heilige schaal voor het branden van je wierook. De abaloneschelp beschermt je handen en versterkt de energie van de rook die opstijgt tijdens het ritueel.',
  edk_cont_item7_tag: 'Ritueel',
  edk_cont_item8_name: 'Uilenveer',
  edk_cont_item8_desc: 'Een krachtig ritueel instrument. De uilenveer verspreidt de heilige rook door de ruimte en geldt als een krachtig beschermend symbool in vele spirituele tradities.',
  edk_cont_item8_tag: 'Ritueel',
  edk_cont_item9_name: 'Brandkool',
  edk_cont_item9_desc: 'Speciaal houtskool voor het branden van je wierookmix. Brandkool zorgt voor een gelijkmatige, langdurige verbranding waardoor de kracht van de kruiden volledig vrijkomt.',
  edk_cont_item9_tag: 'Branden',
  edk_cont_item10_name: 'Witte Kaars',
  edk_cont_item10_desc: 'Zuivere witte kaars om de intentie van het ritueel te versterken en het licht tegenover de duisternis te symboliseren. Verlicht je ritueel en trekt positieve energie aan.',
  edk_cont_item10_tag: 'Licht',

  // ── EDKProblems ──
  edk_prob_badge: '✦ Voor Wie Is Dit Pakket? ✦',
  edk_prob_title: 'Herken Jij',
  edk_prob_title2: 'Jouw Situatie?',
  edk_prob_sub: 'De Destroy Kit is ontwikkeld voor drie specifieke, ernstige situaties. Lees welke het meest op jouw situatie lijkt.',
  edk_prob_symptoms_label: 'Herkenbare Signalen',
  edk_prob_order_btn: 'Bestel de Destroy Kit — €79,95',
  edk_prob1_tag: 'Baby & Kinderkamers',
  edk_prob1_title: 'Je Baby Schrikt Elke Nacht Wakker',
  edk_prob1_sub: 'Onrust, angst en tranen zonder reden',
  edk_prob1_p1: 'Het begon met één nacht. Daarna twee. Daarna elke nacht hetzelfde patroon — jouw kindje huilt, schrikt wakker, staart naar een hoek van de kamer alsof het daar iets ziet. Je hebt alles geprobeerd. Nieuwe speen, zachte muziek, meer knuffels. Niets helpt.',
  edk_prob1_p2: 'Wat de meeste ouders niet weten: baby\'s en jonge kinderen zijn extreem gevoelig voor energieën. Ze voelen wat volwassenen niet meer kunnen voelen. Wanneer een baby aanhoudend schrikt, huilt of niet wil slapen in een bepaalde kamer, is dat in veel tradities een teken dat de ruimte negatief belast is.',
  edk_prob1_p3: 'De Evil Energy Destroy Kit is speciaal ontworpen voor dit soort gevallen. De kruidenwierookmix met salie, ghandak en hing reinigt de kamer op energetisch niveau. De Blueprint legt je stap voor stap uit hoe je de kamer volledig vrijmaakt — zodat jouw kindje eindelijk weer rustig kan slapen.',
  edk_prob1_s1: 'Baby schrikt herhaaldelijk wakker op hetzelfde tijdstip',
  edk_prob1_s2: 'Kijkt angstig naar dezelfde hoek of plek in de kamer',
  edk_prob1_s3: 'Rusteloos slapen zonder medische oorzaak',
  edk_prob1_s4: 'Plotseling veranderd gedrag na verhuizing',
  edk_prob2_tag: 'Nieuwe Woning of Zaak',
  edk_prob2_title: 'Een Nieuw Begin Verdient Een Schone Lei',
  edk_prob2_sub: 'Negatieve energie van het verleden vernietigen',
  edk_prob2_p1: 'Iedereen die voor jou in dat huis of die zaak heeft gewoond of gewerkt, heeft zijn energie achtergelaten. Ruzies. Verdriet. Jaloezie. Financiële zorgen. Mislukking. Die energie kleeft aan de muren, de vloeren, de drempels — en het wacht op de volgende bewoner. Op jou.',
  edk_prob2_p2: 'In veel culturen is het reinigen van een nieuwe ruimte een heilig ritueel vóór je intrekt. Niet voor niets. Wanneer je een nieuwe zaak begint in een ruimte waar een vorige ondernemer failliet is gegaan, neem je zijn energetische erfenis mee. Wanneer je een huis betrekt waar spanningen heersten, voel je dat soms direct — een zwaar gevoel, geen energie, dingen die niet lopen.',
  edk_prob2_p3: 'De Destroy Kit geeft je alles wat je nodig hebt om die oude energie volledig te vernietigen en jouw ruimte opnieuw te laden. De abaloneschelp, uilenveer en de complete wierookmix zorgen samen voor een diepe ruimtereiniging. De Blueprint legt het ritueel van A tot Z uit.',
  edk_prob2_s1: 'Aanhoudend zwaar gevoel in de nieuwe ruimte',
  edk_prob2_s2: 'Zaken of projecten die maar niet van de grond komen',
  edk_prob2_s3: 'Constante tegenslag vanaf het moment van intrekken',
  edk_prob2_s4: 'Gevoel dat de energie van de vorige bewoner er nog is',
  edk_prob3_tag: 'Aanwezigheid van een Entiteit',
  edk_prob3_title: 'Je Bent Niet Alleen — En Je Weet Het',
  edk_prob3_sub: 'Voor wie een aanwezigheid waarneemt',
  edk_prob3_p1: 'Het begint subtiel. Een gevoel dat je bekeken wordt. Schaduwen in je ooghoek. Geluiden die je niet kunt verklaren. Je wordt wakker op hetzelfde tijdstip midden in de nacht en voelt dat er iets in de kamer aanwezig is. Je zegt er niets over omdat je bang bent dat mensen je niet geloven.',
  edk_prob3_p2: 'Maar je weet wat je voelt. En in tegenstelling tot wat velen denken, is een aanwezigheid van een entiteit — of het nu een onruste ziel is, een djinn of een andere negatieve kracht — iets dat met de juiste kennis en middelen aangepakt kan worden. Je hoeft het niet te accepteren.',
  edk_prob3_p3: 'De Evil Energy Destroy Kit is in deze situaties meer dan een reinigingsmiddel — het is een wapen. De combinatie van brandkool, ghandak, salie en lobhan in de speciale mix heeft door eeuwen van gebruik bewezen effectief te zijn bij het verdrijven van aanwezigheden. De witte kaars en de uilenveer versterken de intentie. De Blueprint begeleidt je veilig door het volledige destructieritueel.',
  edk_prob3_s1: 'Wakker worden op vaste tijden met gevoel van aanwezigheid',
  edk_prob3_s2: 'Schaduwen of beweging in de ooghoek',
  edk_prob3_s3: 'Plotseling koud gevoel in bepaalde ruimtes',
  edk_prob3_s4: 'Dieren die reageren op onzichtbare aanwezigheid',

  // ── EDKPurchase ──
  edk_purch_test_badge: '✦ Ervaringen ✦',
  edk_purch_test_title: 'Dit Zeggen',
  edk_purch_test_title2: 'Onze Klanten',
  edk_purch_t1_name: 'Sharona K.',
  edk_purch_t1_text: 'Mijn baby sliep al weken niet door. Na het ritueel in de kinderkamer met deze kit was het die nacht meteen al rustiger. Ik huilde van opluchting.',
  edk_purch_t1_sit: 'Kinderkamer',
  edk_purch_t2_name: 'Aziz M.',
  edk_purch_t2_text: 'We hadden een nieuwe zaak geopend op een plek waar drie bedrijven eerder failliet waren gegaan. Na de Destroy Kit ritueel draaien we nu eindelijk winst.',
  edk_purch_t2_sit: 'Nieuwe Zaak',
  edk_purch_t3_name: 'Leila V.',
  edk_purch_t3_text: 'Ik durfde al maanden niet meer alleen te slapen in mijn slaapkamer. Na het destructieritueel is het gevoel van aanwezigheid volledig weg.',
  edk_purch_t3_sit: 'Aanwezigheid',
  edk_purch_t4_name: 'Rania H.',
  edk_purch_t4_text: 'De Blueprint maakt het zo makkelijk. Ik had nooit gedacht dat ik dit zelf kon. Het werkte de eerste keer al perfect.',
  edk_purch_t4_sit: 'Nieuwe Woning',
  edk_purch_cta_badge: '✦ Doe Het Nu ✦',
  edk_purch_cta_title: 'Vernietig De Kwade',
  edk_purch_cta_title2: 'Energie Voor Altijd',
  edk_purch_cta_sub: 'Stop met accepteren wat je niet hoeft te accepteren. Met de juiste kennis en materialen kan jij dit zelf aanpakken — vandaag.',
  edk_purch_kit_label: 'Evil Energy Destroy Kit Compleet',
  edk_purch_old_price: '€99,95',
  edk_purch_includes_label: 'Inclusief Blueprint, Wierookmix & Complete Rituele Set',
  edk_purch_added_btn: 'Toegevoegd aan wagen!',
  edk_purch_add_btn: 'In Wagen — €79,95',
  edk_purch_safe_pay: 'Veilig betalen via Stripe · creditcard & iDEAL',
  edk_purch_feat1: 'Blueprint Inbegrepen',
  edk_purch_feat2: 'Speciale Kruidenmix',
  edk_purch_feat3: 'Abalone Schelp + Veer',
  edk_purch_feat4: 'Brandkool + Kaars',
  edk_purch_g1: '100% Puur Natuurlijk',
  edk_purch_g2: 'Snel Verzonden',
  edk_purch_g3: 'Wereldwijde Verzending',
  edk_purch_g4: 'ZpiritualZ Garantie',

  // ── Blue Protect Ritual Steps ──
  bp_rit1_s1: 'Begin je dag met een warm bad of douche. Gebruik de Blue Protect Soap met langzame, opwaartse bewegingen van voet naar hoofd — dit volgt de richting van energiestroom.',
  bp_rit1_s2: 'Laat de zeep 1–2 minuten intrekken terwijl je visualiseert hoe een helder blauw licht je volledig omhult en beschermt.',
  bp_rit1_s3: 'Spoel af. Droog jezelf voorzichtig af en spray de Blue Protect Spray 4× rondom je lichaam in een cirkelbeweging.',
  bp_rit1_s4: 'Spray ook op polsen en nek. Sluit je ogen en zeg of denk bewust: "Ik ben beschermd. Negativiteit heeft geen toegang tot mijn aura."',

  bp_rit2_s1: 'Vul een warm bad en voeg 3 eetlepels Blue Protect Powder toe. Roer met je hand drie keer met de klok mee en spreek een beschermende intentie uit.',
  bp_rit2_s2: 'Laat een Blue Protect Ball oplossen in het badwater — het blauwe extract lost langzaam op en versterkt de reinigingswerking van het bad.',
  bp_rit2_s3: 'Ga in bad en ontspan. Laat het blauwe water 20–25 minuten zijn werk doen. Adem bewust en rustig.',
  bp_rit2_s4: 'Dompel je hoofd drie keer volledig onder. Bij elk moment stel je je voor hoe negatieve energie volledig van je wegspoelt.',
  bp_rit2_s5: 'Stap uit bad zonder af te spoelen met schoon water — laat de beschermende laag van het poeder op je huid behouden.',

  bp_rit3_s1: 'Begin bij de voordeur. Strooi een dunne lijn Blue Protect Powder voor de drempel, van links naar rechts — dit creëert een beschermende barrière.',
  bp_rit3_s2: 'Loop door elk vertrek in de richting van de klok. Strooi een kleine hoeveelheid powder in elke hoek van de kamer.',
  bp_rit3_s3: 'Spray de Blue Protect Spray in elk vertrek: 2–3 sprays omhoog, richting het plafond.',
  bp_rit3_s4: 'Sluit het ritueel af bij de voordeur met een extra laag powder en spreek bewust uit dat kwade energieën niet meer welkom zijn in jouw thuis.',

  bp_rit4_s1: 'Breng een kleine hoeveelheid Blue Protect Powder aan op het voorhoofd van het kind of de zwangere vrouw — dit is het traditionele beschermingsteken.',
  bp_rit4_s2: 'Breng ook aan op polsen en enkels. Dit zijn de energetisch gevoeligste punten van het lichaam.',
  bp_rit4_s3: 'Spray de Blue Protect Spray licht rondom de persoon — hou de spray op armlengte afstand en spray van hoofd naar voeten.',
  bp_rit4_s4: 'Herhaal elke ochtend voor vertrek of na bezoek van veel mensen. Na een bezoek aan drukke plaatsen altijd herhalen.',

  // ── Evil Energy Ritual Steps ──
  ee_rit1_s1: 'Vul het bad met warm water en voeg een flinke scheut Evil Energy Destroy Cologne toe aan het badwater. Roer met je hand drie keer met de klok mee.',
  ee_rit1_s2: 'Stap in bad en laat het water 5 minuten intrekken terwijl je rustig ademt en je intentie stelt: bescherming voor de komende dag.',
  ee_rit1_s3: 'Was je lichaam langzaam met de Evil Energy Destroy Zeep — van voet naar hoofd, met opwaartse bewegingen. Visualiseer hoe hing een afwerend schild om je aura vormt.',
  ee_rit1_s4: 'Laat de zeep 2 minuten intrekken. Spoel af. Droog jezelf af zonder haast. De bescherming blijft de hele dag actief.',

  ee_rit2_s1: 'Neem een hoeveelheid Baby Hing Pasta ter grootte van een erwt op je vinger.',
  ee_rit2_s2: 'Smeer de pasta zachtjes in de haren van de baby, dicht bij de schedel achter het hoofd. Dit is het traditionele beschermingsteken.',
  ee_rit2_s3: 'Alternatief: maak een klein balletje van de pasta en leg dit onder het kussen van de baby voor bescherming tijdens de slaap.',
  ee_rit2_s4: 'Vervang de pasta dagelijks vers voor optimale werkzaamheid. Gebruik niet op het gezicht of open huid.',

  ee_rit3_s1: 'Open alle ramen en deuren. Begin bij de meest achterste kamer van het huis.',
  ee_rit3_s2: 'Doe een theelepel Hing Poeder op gloeiende houtskool of in een wierookbrander. Laat de rook de kamer vullen terwijl je de kamer door loopt.',
  ee_rit3_s3: 'Beweeg van kamer naar kamer richting de voordeur — altijd voorwaarts, nooit terug. Laat de rook in elke kamer even intrekken.',
  ee_rit3_s4: 'Sluit af bij de voordeur. Spray de Evil Energy Destroy Spray 3× in elke hoek van de gang en 2× voor de drempel.',
  ee_rit3_s5: 'Sluit de voordeur en laat het huis 15 minuten gesloten met rook voor volledige werking. Ventileer daarna goed.',

  ee_rit4_s1: 'Smeer de Evil Energy Destroy Hing Olie over een zwarte of witte kaars — van de onderkant omhoog. Dit laadt de kaars met beschermende intentie.',
  ee_rit4_s2: 'Stel je intentie in: spreek of denk bewust uit waartegen je beschermd wilt zijn terwijl je de kaars inwrijft.',
  ee_rit4_s3: 'Steek de kaars aan op een veilige plek. Terwijl de kaars brandt, verspreidt de hing-geur bescherming door de ruimte.',
  ee_rit4_s4: 'Alternatief: voeg 4–5 druppels olie toe aan een indamp schaaltje met warm water. Laat dit de hele dag of nacht werken als continue bescherming.',

  ee_rit5_s1: 'Voeg 3 druppelaars Evil Energy Destroy Cologne toe aan de dweelmer met water. Roer goed door.',
  ee_rit5_s2: 'Begin in de meest achterste kamer van het huis. Dweil in rechte banen, altijd richting de uitgang.',
  ee_rit5_s3: 'Dweil elke kamer van achteren naar voren. Beweeg steeds richting de voordeur — zo beweeg je negatieve energie letterlijk het huis uit.',
  ee_rit5_s4: 'Eindigt bij de voordeur. Dweil de drempel zelf als laatste stap. Laat de vloer drogen zonder afspoelen.',

  // ── Algemeen ──
  common_loading: 'Laden...',
  common_error: 'Er is iets misgegaan. Probeer opnieuw.',
  common_required: 'verplicht',
  common_mostChosen: 'Meest Gekozen',
  common_selected: 'Geselecteerd',
  common_bestseller: 'Bestseller',
  common_new: 'Nieuw',
  common_exclusive: 'Exclusief',
  common_sale: 'Aanbieding',
  common_onceOnly: 'eenmalig',
  common_pay_safe: 'Veilig betalen via Stripe',
  common_reviews: 'reviews',
  common_products: 'producten',
};

export default nl;
